module.exports = __webpack_public_path__ + "static/media/star-img.b3610cd7.svg";